const PI = 3.1415926535897932384626;
import request from "@/common/request.js";
import { Message } from "element-ui";
import moment from "moment";
export const getQueryString = (name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    // return unescape(r[2])
    return decodeURI(r[2]);
  }
  return null;
};

export const timestampData = (data) => {
  if (!data) return "";
  return moment(data).format("YYYY-MM-DD HH:mm:ss");
};
export const updatedGet = (url, param, callMethod) => {
  request.get(url, param).then((response) => {
    console.log(response);
    Message({
      message: response.msg,
      type: "success",
    });
    callMethod();
  });
};

// 字符串逗号转数组
export const strToArray = (str) => {
  if (!str) return [];
  if (Array.isArray(str)) return str;

  if (endWith(str)) {
    let reg = /,$/gi;
    str = str.replace(reg, "");
  }
  let arr = str.split(",").map((item) => {
    if (item) {
      return {
        url: item,
      };
    }
  });
  return arr;
};

export const endWith = (str) => {
  let reg = new RegExp(str + "$");
  return reg.test(str);
};

// 字符串逗号转数组
export const strToArray2 = (str) => {
  console.log(str);
  if (Array.isArray(str)) return str;
  if (!str) return [];
  let arr = str.split(",");
  let arr2 = [];
  arr.forEach((item) => {
    if (item) {
      arr2.push(item);
    }
  });
  return arr2;
};

// 数组图片转url
export const arrayToUrl = (array) => {
  let url = "";
  for (let i = 0; i < array.length; i++) {
    url += array[i].url + ",";
  }
  return url.substring(0, url.length - 1);
};
// 乡镇类别判断
export const townTypeJudge = (townName) => {
  if (townName.indexOf("乡") > -1) {
    return 1;
  } else if (townName.indexOf("镇") > -1) {
    return 2;
  } else if (townName.indexOf("街道") > -1) {
    return 3;
  } else if (townName.indexOf("社区") > -1) {
    return 4;
  } else {
    return 0;
  }
};

/**
 * 数字运算（主要用于小数点精度问题）
 * @param {number} a 前面的值
 * @param {"+"|"-"|"*"|"/"} type 计算方式
 * @param {number} b 后面的值
 * @example
 * ```js
 * // 可链式调用
 * const res = computeNumber(1.3, "-", 1.2).next("+", 1.5).next("*", 2.3).next("/", 0.2).result;
 * console.log(res);
 * ```
 */
export const computeNumber = (a, type, b) => {
  /**
   * 获取数字小数点的长度
   */
  function getDecimalLength(n) {
    const decimal = n.toString().split(".")[1];
    return decimal ? decimal.length : 0;
  }
  /**
   * 修正小数点
   */
  const amend = (n, precision = 3) => {
    if (type == "/") {
      return parseFloat(Number(n).toPrecision(4));
    }
    return parseFloat(Number(n).toPrecision(precision));
  };
  const power = Math.pow(
    10,
    Math.max(getDecimalLength(a), getDecimalLength(b)),
  );
  let result = 0;

  a = amend(a * power);
  b = amend(b * power);

  switch (type) {
    case "+":
      result = (a + b) / power;
      break;
    case "-":
      result = (a - b) / power;
      break;
    case "*":
      result = (a * b) / (power * power);
      break;
    case "/":
      result = a / b;
      break;
  }

  result = amend(result);

  return {
    /** 计算结果 */
    result,
    /**
     * 继续计算
     * @param {"+"|"-"|"*"|"/"} nextType 继续计算方式
     * @param {number} nextValue 继续计算的值
     */
    next(nextType, nextValue) {
      return computeNumber(result, nextType, nextValue);
    },
  };
};

function transformLon(x, y) {
  let ret =
    300.0 +
    x +
    2.0 * y +
    0.1 * x * x +
    0.1 * x * y +
    0.1 * Math.sqrt(Math.abs(x));
  ret +=
    ((20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0) /
    3.0;
  ret +=
    ((20.0 * Math.sin(x * PI) + 40.0 * Math.sin((x / 3.0) * PI)) * 2.0) / 3.0;
  ret +=
    ((150.0 * Math.sin((x / 12.0) * PI) + 300.0 * Math.sin((x / 30.0) * PI)) *
      2.0) /
    3.0;
  return ret;
}

function transformLat(x, y) {
  let ret =
    -100.0 +
    2.0 * x +
    3.0 * y +
    0.2 * y * y +
    0.1 * x * y +
    0.2 * Math.sqrt(Math.abs(x));
  ret +=
    ((20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0) /
    3.0;
  ret +=
    ((20.0 * Math.sin(y * PI) + 40.0 * Math.sin((y / 3.0) * PI)) * 2.0) / 3.0;
  ret +=
    ((160.0 * Math.sin((y / 12.0) * PI) + 320 * Math.sin((y * PI) / 30.0)) *
      2.0) /
    3.0;
  return ret;
}

function outOfChina(lon, lat) {
  if ((lon < 72.004 || lon > 137.8347) && (lat < 0.8293 || lat > 55.8271)) {
    return true;
  } else {
    return false;
  }
}

function delta(lat, lon) {
  let a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
  let ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
  let dLat = transformLat(lon - 105.0, lat - 35.0);
  let dLon = transformLon(lon - 105.0, lat - 35.0);
  let radLat = (lat / 180.0) * PI;
  let magic = Math.sin(radLat);
  magic = 1 - ee * magic * magic;
  let sqrtMagic = Math.sqrt(magic);
  dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * PI);
  dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * PI);
  return {
    lat: lat + dLat,
    lon: lon + dLon,
  };
}

export const wgs84togcj02 = (arr) => {
  let lat = arr[0];
  let lon = arr[1];

  if (outOfChina(lat, lon)) {
    return [lat, lon];
  }
  let d = delta(lat, lon);
  return [d.lat, d.lon];
};

export const changeURLArg = (url, arg, arg_val) => {
  let pattern = arg + "=([^&]*)";
  let replaceText = arg + "=" + arg_val;
  if (url.match(pattern)) {
    let tmp = "/(" + arg + "=)([^&]*)/gi";
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  } else {
    if (url.match("[\?]")) {
      return url + "&" + replaceText;
    } else {
      return url + "?" + replaceText;
    }
  }
};

export const removeNullAndUndefined = (obj) =>
  Object.entries(obj).reduce(
    (a, [k, v]) => (v == null ? a : ((a[k] = v), a)),
    {},
  );

export const pluck = (objs, property) => {
  if (Array.isArray(objs)) return objs.map((obj) => obj[property]);
  else return [];
};
// 获取数组最后一个元素
export const lastItem = (arr) => arr.slice(-1)[0];

// 删除 对象里面 空字符串 null undefined的属性
export const removeNullAndUndefinedInObject = (obj) => {
  Object.keys(obj).forEach((key) => {
    console.log(obj[key]);
    if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      delete obj[key];
    }
  });
  return obj;
};

// 时间限制
//大于等于今天
export const equalToday = (date) => {
  return date.getTime() <= Date.now() - 86400000;
};

// 时间限制
// 开始时间 不能大于 结束时间
export const compareDate = (startDate, endDate) => {
  return moment(startDate).isAfter(endDate);
};

// 提取数组中的对象的某个属性
export const ObjectUrlToSyrting = (obj) => {
  let arr = [];
  let tmpStr = "";
  for (let i in obj) {
    if (obj[i] instanceof Array) {
      obj[i].map((item) => {
        arr.push(item.url);
      });
      tmpStr += arr.join(",");
    }
  }
  return tmpStr;
};

// 数组参数转 对象(url 参数)
export const strToArrObj = (arr, name) => {
  // 字符串转数组
  console.log("arr", arr);
  let arr1 = arr.split(",");
  let returnArr = [];
  arr1.map((item) => {
    let obj = {};
    if (item) {
      obj["url"] = item;
      obj["name"] = name || "";
      returnArr.push(obj);
    }
  });

  return returnArr;
};

// 中国地理边界范围（近似值）
const CHINA_BOUNDS = {
  minLon: 73.66, // 最西端 新疆帕米尔高原
  maxLon: 135.05, // 最东端 黑龙江黑瞎子岛
  minLat: 3.86, // 最南端 曾母暗沙
  maxLat: 53.55, // 最北端 漠河以北黑龙江主航道
};

// 校验函数
export const validateChinaCoordinates = (lng, lat) => {
  // 有效性校验
  if (typeof lng !== "number" || typeof lat !== "number") {
    return false;
  }
  if (!lng || !lat) {
    return false;
  }

  // 范围校验
  return (
    lng >= CHINA_BOUNDS.minLon &&
    lng <= CHINA_BOUNDS.maxLon &&
    lat >= CHINA_BOUNDS.minLat &&
    lat <= CHINA_BOUNDS.maxLat
  );
};
